import { history } from '@umijs/max';
import { Button, message, Space } from 'antd';
import { useId, useRef, useState } from 'react';
import { useProjects } from '@/context/ProjectContext';
import { InteractionManager } from '@/SDK/InteractionManager';
import runtimeConfig from '@/utils/runtimeConfig';
import CreateProjectModal from '../CreateProjectModal';

const NavBarFunctions: React.FC = () => {
	const [modalOpen, setModalOpen] = useState(false);
	const fileInputId = useId();
	const consFileInputId = useId();
	const ursaFileRef = useRef<HTMLInputElement>(null!);
	const im: InteractionManager = InteractionManager.getInstance();
	const { refreshProjects } = useProjects();

	const handleImport = async (file: any) => {
		if (!file) {
			message.error('Please select a file first.');
			return;
		}
		try {
			//TODO: im.API.uploadExcelData is FedEx spefic, needs to be renamed in the backend
			const response = runtimeConfig.isFedEx
				? await im.API.uploadExcelData(file)
				: await im.API.createProjectAuto(file);
			// const response = await im.API.uploadExcelData(file)
			if (response.Error) {
				console.error('Upload failed:', response);
				message.error(response.Payload);
				return;
			} else {
				refreshProjects();
				message.success('Bookings added successfully!');
			}
		} catch (err: any) {
			console.error('Unexpecteuploadd error during upload:', err);
			message.error(`Error uploading file: ${err.message || 'Unknown error'}`);
		} finally {
			const input = document.getElementById(fileInputId) as HTMLInputElement;
			if (input) input.value = '';
		}
	};

	const handleConsImport = async (file: any) => {
		if (!file) {
			message.error('Please select a file first.');
			return;
		}
		try {
			const response = await im.API.uploadConsExcelData(file);
			if (response.Error) {
				console.error('Upload failed:', response);
				message.error(response.Payload);
				return;
			} else {
				refreshProjects();
				message.success('Consolidations added successfully!');
			}
		} catch (err: any) {
			console.error('Unexpected error during upload:', err);
			message.error(`Error uploading file: ${err.message || 'Unknown error'}`);
		} finally {
			const input = document.getElementById(
				consFileInputId,
			) as HTMLInputElement;
			if (input) input.value = '';
		}
	};

	const handleUrsaUpload = async (file: File | undefined) => {
		if (!file) {
			message.error('Please select a file first.');
			return;
		}
		try {
			const response = await im.API.splitRulesUpdate(file);
			if (response.Error) {
				console.error('Upload failed:', response);
				message.error(response.Payload);
				return;
			} else {
				message.success('URSA uploaded successfully!');
			}
		} catch (err: any) {
			console.error('Error during upload:', err);
			message.error(`Error uploading file: ${err.message || 'Unknown error'}`);
		} finally {
			ursaFileRef.current.value = '';
		}
	};

	return (
		<Space>
			<Button onClick={() => setModalOpen(true)}>new project</Button>
			{runtimeConfig.isFedEx && (
				<>
					<Button onClick={() => document.getElementById(fileInputId)?.click()}>
						upload bookings
						<input
							type="file"
							accept=".json,.csv,.xlsx,.xls,.rtf"
							style={{ display: 'none' }}
							id={fileInputId}
							onChange={(e) => {
								const file = e.target.files?.[0];
								if (file) {
									handleImport(file);
								}
							}}
						/>
					</Button>
					<Button
						onClick={() => document.getElementById(consFileInputId)?.click()}
					>
						upload consolidations
						<input
							type="file"
							accept=".json,.csv,.xlsx,.xls,.rtf"
							style={{ display: 'none' }}
							id={consFileInputId}
							onChange={(e) => {
								const file = e.target.files?.[0];
								if (file) {
									handleConsImport(file);
								}
							}}
						/>
					</Button>
					<Button onClick={() => ursaFileRef.current.click()}>
						upload URSA table
						<input
							ref={ursaFileRef}
							type="file"
							accept=".xlsx"
							style={{ display: 'none' }}
							onChange={(e) => handleUrsaUpload(e.target.files?.[0])}
						/>
					</Button>
				</>
			)}
			<Button
				onClick={() => {
					refreshProjects();
					history.push('/projects');
				}}
			>
				archive
			</Button>

			<CreateProjectModal
				open={modalOpen}
				onClose={() => setModalOpen(false)}
			/>
		</Space>
	);
};

export default NavBarFunctions;
